import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SessionBaseComponent } from '../../../../shared/components/session.base.component';
import { WarehousingSearchService } from '../../services/warehousing-search.service';
import { CommonDataService } from '../../../../core/services/common-data.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';

@Component({
  selector: 'laas-warehousing-edit-related-bill',
  templateUrl: './warehousing-edit-related-bill.component.html',
  styleUrls: ['./warehousing-edit-related-bill.component.scss']
})
export class WarehousingEditRelatedBillComponent extends SessionBaseComponent implements OnInit {

  formGroup: FormGroup;
  isVisible: boolean;
  @Output() visibleChange = new EventEmitter<any>();

  deliveryTypeOptions: any[];
  shipTermOptions: any[];
  billCorpOptions: any[];
  defaultBillCorpOptions: any[];
  orgIdOptions: any[];
  preOrgId:string = "";
  deliverySubTypeOptions: any[] = [];

  @Input() warehousingHeader: any;

  constructor(
    injector: Injector,
    private formBuilder: FormBuilder,
    private commonDataService: CommonDataService,
    private warehousingSearchService: WarehousingSearchService,
    private facilityService: FacilityService) {
    super(injector);

    this.formGroup = this.formBuilder.group({
      deliveryType: null,
      shipTerm: null,
      billCorp: null,
      orgId: ['', Validators.required ],
      deliverySubType: ['', Validators.required ]
    });

    this.isVisible = false;

    this.deliveryTypeOptions = [];
    this.shipTermOptions = [];
    this.billCorpOptions = [];
    this.defaultBillCorpOptions = [];
    this.orgIdOptions = [];

    this.warehousingHeader = {};
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'InboundDeliveryType').subscribe({
      next: result => {
        this.deliveryTypeOptions = [...result].map((x: any) => {
          return {
            label: x.codeDesc,
            value: x.codeKey,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ShipTerm').subscribe({
      next: result => {
        this.shipTermOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.facilityService.getOrgOptionsByWhDetail(this.warehousingHeader.facility, this.warehousingHeader.whNo).subscribe({
      next: result => {
        this.orgIdOptions = [...result].map((x: any) => {
          return {
            label: `${x.legalEntityOUCode}-${x.legalEntityOUName}(${x.legalEntityReferenceCode})`,
            value: x.legalEntityOUCode,
          };
        });
      }
    });

    this.preOrgId = this.warehousingHeader.orgId;
    this.changeBillCorpOptions(true);

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'InboundDeliverySubType').subscribe({
      next: result => {
        this.deliverySubTypeOptions = [...result].map((x: any) => {
          return {
            label: x.codeDesc,
            value: x.codeKey,
          };
        });
      }
    });

  }

  @Input() get visible(): any {
    return this.isVisible;
  }

  set visible(value: any) {
    this.isVisible = value;
  }

  dialogVisibleChange(value: boolean): void {
    this.visibleChange.emit(value);
  }

  changeShipTerm(event: any) {
    if (!event.value) {
      this.formGroup.controls.shipTerm.setValue('');
    }
  }

  changeBillCorpOptions(isInit?: boolean): void {
    const orgId = this.warehousingHeader.orgId;
    if ( isInit || orgId != this.preOrgId ) {
      this.facilityService.getLetterOrgOptions(this.laasSetting.facility, orgId)
      .subscribe({
        next: (options: any[]) => {

          this.billCorpOptions = [...options].map((x: any) => {
            return {
              label: `${x.billOUCode}-${x.billOUName} (${x.billReferenceCode})`,
              value: x.billOUCode,
            };
          });

          if (this.billCorpOptions.length === 0 || isNullOrEmpty(this.billCorpOptions[0].value) ){
            this.toastService.error(this.translateService.instant("ReceiptFormHeaderDetails.Message.CantFindBillCorp"))
            this.warehousingHeader.orgId = this.preOrgId;
            this.formGroup.controls.orgId.setValue(this.preOrgId);
            return;
          }else{
            this.formGroup.controls.billCorp.setValue(this.billCorpOptions[0].value);
            this.warehousingHeader.billCorp = this.billCorpOptions[0].value;
            this.preOrgId = orgId;
          }
        }
      });
    }
  }

  saveRelatedBill(event: any): void {
    if (this.formGroup.invalid) {
      console.log(this.formGroup.controls);
      this.toastService.warn('請檢查是否有必填欄位尚未填寫');
      return;
    }

    const requestParam = {
      whNo: this.warehousingHeader.whNo,
      updateUser: this.userProfile.userName,
      deliveryType: this.formGroup.value.deliveryType,
      shipTerm: this.formGroup.value.shipTerm,
      billCorp: this.formGroup.value.billCorp,
      orgId: this.formGroup.value.orgId,
      deliverySubType: this.formGroup.value.deliverySubType
    };

    this.warehousingSearchService.updateWarehousingRelatedBilling(requestParam).subscribe({
      next: result => {
        this.translateService.get('Common.Message.SuccessSave').subscribe({
          next: msg => {
            this.toastService.success(msg);
            this.dialogVisibleChange(false);
          }
        });
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.dialogVisibleChange(false);
      }
    });
  }
}
